import React, { useState } from "react";
import ProfileContainer from "../components/ProfileContainer";
import { Typography } from "antd";
import ExpandableHtmlText from "../../../components/ExpandableHtmlText";

const MAX_LENGTH = 4;

const TeamRow = ({team, ...props}) => {
    const [isBioOpen, setIsBioOpen] = useState(false);

    return (
        <div key={team.id} className="flex flex-col gap-3">

            <img src={team.banner_image_path} />

            <p className="text-lg">{team.name}</p>

            <ExpandableHtmlText
                shouldExpand={isBioOpen}
                onChange={setIsBioOpen}
                showReadMore={false}
                content={TB.stripHtml(team.bio)?.length > 0 ? team.bio : '<i>Bio Not Provided</i>'}
                maxHeight={70}>
                <button
                    type="button"
                    className="btn-outline bg-wrippleOffWhite h-6 w-6 shrink-0 flex items-center justify-center"
                    onClick={() => {
                        setIsBioOpen(!isBioOpen)
                    }}
                >
                    <i className={TB.mapClass("fa fa-chevron-down transition text-base", { 'rotate-180': isBioOpen })} />
                </button>
            </ExpandableHtmlText>

        </div>
    )
}

const AgencyProfileTeams = ({ items }) => {
    const [isTeamsOpen, setIsTeamsOpen] = useState(false);

    return (
        <div id="teams" className="pt-2 pb-8">
            <ProfileContainer>
                <div>
                    <h4 className="text-lg pb-6">Teams {!!items.length && `(${items.length})`}</h4>

                    {!items.length && (
                        <div className="py-8 text-center">
                            <p className="text-base">No Teams Available</p>
                        </div>
                    )}


                    <div className="flex flex-col relative items-stretch gap-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {items?.slice(0, isTeamsOpen ? items.length : MAX_LENGTH).map(team => {
                                return (
                                    <TeamRow team={team} key={team.id} />
                                )
                            })}
                        </div>
                    </div>

                    {items.length > MAX_LENGTH && (
                        <div className="pt-6 flex justify-end">
                            <button
                                type="button"
                                className="btn-outline flex items-center gap-2 p-1.5 px-2.5 transition hover:bg-wrippleOffWhite"
                                onClick={() => setIsTeamsOpen(!isTeamsOpen)}
                            >
                                <p>{items.length - MAX_LENGTH} {isTeamsOpen ? 'less' : 'more'}</p>
                                <div className="bg-wrippleOffWhite h-6 w-6 shrink-0 flex items-center justify-center">
                                    <i className={TB.mapClass("fa fa-chevron-down transition text-base", { 'rotate-180': isTeamsOpen })} />
                                </div>
                            </button>
                        </div>
                    )}
                </div>
            </ProfileContainer>
        </div>
    )
}

export default AgencyProfileTeams;